import styled from "styled-components";

import PropertyCard from "../../entities/property/PropertyCard";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 16px 0;
`;

export default function PropertiesOverview(props) {
    const { className, properties } = props;
    return (
        <Styled
            className={ className }
        >
            {
                properties
                    .map((property) => property.parameter.id)
                    .filter((e, i, a) => a.indexOf(e) === i)
                    .map(
                        (parameterID) => (
                            <PropertyCard
                                key={ parameterID }
                                parameterID={ parameterID }
                                values={
                                    properties.filter(
                                        (property) => property.parameter.id === parameterID
                                    )
                                }
                            />
                        )
                    )
            }
        </Styled>
    );
};
